<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        md="6"
        sm="6"
      >
        <v-row class="margin20">
          <v-col
            cols="12"
            md="12"
            sm="12"
          >
            <table class="table">
              <tr>
                <td>
                  <img
                    class="imgIcon"
                    src="icon_1.png"
                  >
                  <div class="iconRight">
                    累積發電量<br>
                    <span class="textred">{{ dashboard.value }}</span><br>
                    kWh
                  </div>
                </td>
                <td>
                  <img
                    class="imgIcon"
                    src="icon_2.png"
                  >
                  <div class="iconRight">
                    本日發電量<br>
                    <span class="textred"> {{ dashboard.eac_today }}</span><br>
                    kWh
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <img
                    class="imgIcon"
                    src="icon_3.png"
                  >
                  <div class="iconRight">
                    系統建置量<br>
                    <span class="textred"> {{ dashboard.build_value }}</span><br>
                    KW
                  </div>
                </td>
                <td>
                  <img
                    class="imgIcon"
                    src="icon_4.png"
                  >
                  <div class="iconRight">
                    逆變電效應<br>
                    <span class="textred"> {{ dashboard.four }}</span><br>
                    %
                  </div>
                </td>
              </tr>
            </table>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="12"
            sm="12"
          >
            <table class="table margin20">
              <tr>
                <td class="redbg">
                  累積二氧化碳減少量
                </td>
                <td>0</td>
                <td class="redbg">
                  以承受最大陣風
                </td>
                <td>{{ table.max_winds }}</td>
              </tr>
              <tr>
                <td class="redbg">
                  DC輸入功率
                </td>
                <td>{{ table.Inputpowera }} kW</td>
                <td class="redbg">
                  目前風速
                </td>
                <td>NA</td>
              </tr>
              <tr>
                <td class="redbg">
                  AC輸出功率
                </td>
                <td>{{ table.Outputpower }} kW</td>
                <td class="redbg">
                  -
                </td>
                <td>-</td>
              </tr>
              <tr>
                <td class="redbg">
                  日照
                </td>
                <td>{{ table.irradiance }}</td>
                <td class="redbg">
                  -
                </td>
                <td>-</td>
              </tr>
              <tr>
                <td class="redbg">
                  模組溫度
                </td>
                <td>{{ table.module_temp }}</td>
                <td class="redbg">
                  -
                </td>
                <td>-</td>
              </tr>
              <tr>
                <td class="redbg">
                  環境溫度
                </td>
                <td>{{ table.env_temp }}</td>
                <td class="redbg">
                  -
                </td>
                <td>-</td>
              </tr>
              <tr>
                <td class="redbg">
                  每kW系統日均發電度數
                </td>
                <td>
                  {{ (dashboard.eac_today / dashboard.build_value).toFixed(2) }}
                </td>
                <td class="redbg">
                  -
                </td>
                <td>-</td>
              </tr>
            </table>
          </v-col>
        </v-row>
      </v-col>

      <v-col
        cols="12"
        md="6"
        sm="6"
      >
        <div class="left status">
          <div v-if="exec_gateway_status">
            <img
              class="img"
              src="icon_green.jpg"
            > 系統上線
          </div>
          <div v-else>
            <img
              class="img"
              src="icon_red.jpg"
            > 系統離線中
          </div>
        </div>
        <v-select
          v-model="fieldListValue"
          style="float: left"
          :items="fieldList"
          label="選擇場域"
          solo
          @input="fieldChange"
        />
        <div class="both" />

        <v-col
          cols="12"
          md="12"
          sm="12"
        >
          <div class="searchbg">
            <div
              style="
                display: flex;
                flex-wrap: wrap;
                flex: 1 1 auto;
                margin-right: -12px;
                margin-left: -12px;
              "
              class="dateselect"
            >
              <v-col
                cols="12"
                md="1"
                sm="1"
                class="lineheight40"
              >
                From
              </v-col>
              <v-col
                cols="12"
                md="4"
                sm="4"
              >
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  width="100px"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="fromdate"
                      class="date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="fromdate"
                    @input="menu2 = false"
                  />
                </v-menu>
              </v-col>
              <v-col
                cols="12"
                md="1"
                sm="1"
                class="lineheight40"
              >
                To
              </v-col>
              <v-col
                cols="12"
                md="4"
                sm="4"
              >
                <v-menu
                  v-model="menu3"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="todate"
                      class="date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="todate"
                    @input="menu3 = false"
                  />
                </v-menu>
              </v-col>
            </div>
            <div class="dateselect">
              <div class="left">
                <img
                  class="imgSelectDate"
                  src="Today.png"
                  @click="todayBtn"
                >
                <img
                  class="imgSelectDate"
                  src="Week.png"
                  @click="weekViewBtn"
                >
                <img
                  class="imgSelectDate"
                  src="Month.png"
                  @click="monthViewBtn"
                >
                <img
                  class="imgSelectDate"
                  src="Year.png"
                  @click="yearViewBtn"
                >
              </div>

              <div
                class="left"
                style="width: 100px"
              >
                <v-btn
                  class="left"
                  small
                  outlined
                  @click="preDateBtn"
                >
                  ＜＜
                </v-btn>
                <v-btn
                  class="left"
                  small
                  outlined
                  @click="searchBtn"
                >
                  查詢
                </v-btn>
                <v-btn
                  class="left"
                  small
                  outlined
                  @click="nextDateBtn"
                >
                  ＞＞
                </v-btn>
              </div>
            </div>
            <div class="dateselect both">
              <v-btn
                outlined
                @click="weekBtn"
              >
                最近一周
              </v-btn>
              <v-btn
                outlined
                @click="monthBtn"
              >
                最近一月
              </v-btn>
              <v-btn
                outlined
                @click="yearBtn"
              >
                最近一年
              </v-btn>
            </div>
          </div>
        </v-col>

        <v-row>
          <v-col
            cols="12"
            md="12"
          >
            <line-example
              :styles="myStyles" 
              class=""
              :height="200"
              :display="false"
              :chart="chartAna"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LineExample from "./LineChartSolar.js";
import moment from "moment";
import Cookies from "js-cookie";

export default {
  components: { LineExample },
  data: () => ({
     myStyles: {
        height: '300px',
        width: '100%',
        position: 'relative',
      },
    time: null,
    fieldStatus: "",
    chartAna: {},
    updatetime: "",
    fieldList: ["", "測試用"],
    fieldListValue: "",
    deviceList: ["01"],
    dashboard: {
      value: 0,
      eac_today: 0,
      build_value: 0,
      four: 0,
    },
    fromdate: new Date().toISOString().substr(0, 10),
    todate: new Date().toISOString().substr(0, 10),
    menu2: false,
    menu3: false,
    searchType: "today",
    exec_gateway_status: false,
    ip_adrs: "",
    table: {
      irradiance: "NA",
      module_temp: "NA",
      env_temp: "NA",
      winds_speed: "NA",
      max_winds: "NA",
      Inputpowera: 0,
      Outputpower: 0,
    },
  }),
  computed: {
    host() {
      return this.$store.state.host;
    },
    loginInfo() {
      return this.$store.state.loginInfo;
    },
    loginUID() {
      return this.$store.state.loginUID;
    },
    exec_cust_gateway_000() {
      return this.$store.state.exec_cust_gateway_000;
    },
  },
  created: function () {
    Cookies.set("url", "/SolarDashboard");
    this.updatetime = moment().format("YYYY-MM-DD HH:mm:ss");
    this.init();

    this.time = setInterval(() => {
      this.fieldChange(this.fieldListValue);
    }, 600 * 1000);
  },
  unmounted() {
    if (this.time) {
      clearInterval(this.time);
    }
  },
  methods: {
    init() {
      let that = this;
      let nform = {
        cust_id: this.loginInfo.cust_id,
      };

      this.fieldList = [];
      this.$store
        .dispatch("exec_cust_gateway_000", nform)
        .then((res) => {
          if (this.loginUID.superuser == "0") {
            nform = {
              cust_id: this.loginInfo.cust_id,
              uid: this.loginInfo.uid,
            };

            this.$store
              .dispatch("exec_uid_gateway_000", nform)
              .then((res) => {
                if (res != null && res.length > 0) {
                  for (var i = 0; i < res.length; i++) {
                    let gw_no = res[i].gw_no;

                    for (
                      var j = 0;
                      j < this.exec_cust_gateway_000.length;
                      j++
                    ) {
                      let item = this.exec_cust_gateway_000[j];

                      if (gw_no == item.ip_adrs) {
                        this.fieldList.push(item.gw_desc);
                      }
                    }
                  }
                  if (this.fieldList != null && this.fieldList.length > 0) {
                    if (
                      this.fieldListValue == null ||
                      this.fieldListValue == ""
                    ) {
                      this.fieldListValue = this.fieldList[0];
                    } else {
                    }
                  }
                  this.fieldChange(this.fieldListValue);
                }
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            this.fieldList = this.exec_cust_gateway_000.map(function (item) {
              return item.gw_desc;
            });
            if (this.fieldList != null && this.fieldList.length > 0) {
              if (this.fieldListValue == null || this.fieldListValue == "") {
                this.fieldListValue = this.fieldList[0];
              } else {
              }
            }
            this.fieldChange(this.fieldListValue);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    dashboarddata() {
      let ip_adrs = this.ip_adrs; //"54:10:EC:F4:11:3E";
      let sdat = new Date().toISOString().substr(0, 10);
      let edat = new Date().toISOString().substr(0, 10);

      let nform = {
        ip_adrs: ip_adrs,
        sdat: sdat,
        edat: edat,
      };
      this.$store
        .dispatch("exec_solar_byday", nform)
        .then((res) => {
          if (res != null && res.length > 0) {
            if (res[0].eac_today != null) {
              this.dashboard.eac_today = parseFloat(res[0].eac_today);
            } else {
              this.dashboard.eac_today = 0;
            }
          } else {
            this.dashboard.eac_today = 0;
          }
        })
        .catch((err) => {
          console.log(err);
        });

      nform = {
        ip_adrs: ip_adrs,
      };

      this.$store
        .dispatch("exec_solar_general", nform)
        .then((res) => {
          if (res != null && res.length > 0) {
            // console.log(res);
            for (var i = 0; i < res.length; i++) {
              let item = res[i];
              if (item.val_name == "env_temp") {
                this.table.env_temp = item.value;
              }

              if (item.val_name == "max_winds") {
                this.table.max_winds = item.value;
              }

              if (item.val_name == "irradiance") {
                this.table.irradiance = item.value;
              }

              if (item.val_name == "module_temp") {
                this.table.module_temp = item.value;
              }

              if (item.val_name == "winds_speed") {
                this.table.winds_speed = item.value;
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });

      this.$store
        .dispatch("exec_solar_totgen", nform)
        .then((res) => {
          // console.log(res);
          if (res != null && res.length > 0) {
            if (res[0].value != null) {
              this.dashboard.value = parseFloat(res[0].value);
            } else {
              this.dashboard.value = 0;
            }
          } else {
            this.dashboard.value = 0;
          }
        })
        .catch((err) => {
          console.log(err);
        });

      this.$store
        .dispatch("exec_solar_build", nform)
        .then((res) => {
          if (res != null && res.length > 0) {
            if (res[0].build_value != null) {
              this.dashboard.build_value = parseFloat(res[0].build_value);
            } else {
              this.dashboard.build_value = 0;
            }
          } else {
            this.dashboard.build_value = 0;
          }
        })
        .catch((err) => {
          console.log(err);
        });

      this.$store
        .dispatch("exec_solar_efficacy", nform)
        .then((res) => {
          if (res != null && res.length > 0) {
            // console.log(res);
            this.dashboard.four = 0;
            for (var i = 0; i < res.length; i++) {
              let item = res[i];

              if (item.val_name == "input power a") {
                this.table.Inputpowera = parseFloat(item.value);
                //console.log("input power a", item.value);
              }

              if (item.val_name == "output power") {
                this.table.Outputpower = parseFloat(item.value);
                // console.log("output power ", item.value);
              }
            }

            this.dashboard.four =
              (this.table.Outputpower / this.table.Inputpowera) * 100;
            // console.log(this.Outputpower);
            //// console.log(this.Inputpowera);
            this.dashboard.four = this.dashboard.four.toFixed(2);
            //console.log(this.dashboard.four);
          }
        })
        .catch((err) => {
          console.log(err);
        });

      this.todayBtn();
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    fieldChange(val) {
      this.fieldListValue = val;
      this.filterDevice = this.exec_cust_gateway_000.filter(function (
        item,
        index,
        array
      ) {
        return item.gw_desc == val;
      });
      if (this.filterDevice != null && this.filterDevice.length > 0) {
        let nform = {
          ip_adrs: this.filterDevice[0].ip_adrs,
        };
        this.ip_adrs = this.filterDevice[0].ip_adrs;
        this.dashboarddata();
        this.$store
          .dispatch("exec_gateway_status", nform)
          .then((res) => {
            if (res != null && res.length > 0) {
              if (res[0].gateway_sts != null && res[0].gateway_sts > 0) {
                this.exec_gateway_status = true;
              } else {
                this.exec_gateway_status = false;
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    weekViewBtn() {
      this.searchType = "week";
      this.weekSerach();
    },
    monthViewBtn() {
      this.searchType = "month";
      this.monthSearch();
    },
    yearViewBtn() {
      this.searchType = "year";
      this.yearSearch();
    },
    preDateBtn() {
      let start = moment(this.fromdate);
      let end = moment(this.todate);
      end = end.subtract(1, "days").format("YYYY-MM-DD");
      start = start.subtract(1, "days").format("YYYY-MM-DD");
      this.fromdate = start;
      this.todate = end;
      this.searchBtn();
    },
    searchBtn() {
      if (this.searchType == "week") {
        this.weekSerach();
      } else if (this.searchType == "month") {
        this.monthSearch();
      } else if (this.searchType == "year") {
        this.yearSearch();
      } else if (this.searchType == "today") {
        this.todayBtn();
      } else {
        this.todayBtn();
      }
    },
    nextDateBtn() {
      let start = moment(this.fromdate);
      let end = moment(this.todate);
      end = end.add(1, "days").format("YYYY-MM-DD");
      start = start.add(1, "days").format("YYYY-MM-DD");
      this.fromdate = start;
      this.todate = end;
      this.searchBtn();
    },
    weekBtn() {
      let sdat = new Date().toISOString().substr(0, 10);
      let edat = new Date().toISOString().substr(0, 10);

      this.fromdate = sdat;
      this.todate = edat;

      let start = moment(this.fromdate);
      let end = moment(this.todate);
      start = end.subtract(1, "weeks").format("YYYY-MM-DD");
      // console.log(start, end);
      this.fromdate = start;
      this.weekSerach();
    },
    weekSerach() {
      let nform = {
        ip_adrs: this.ip_adrs,
        sdat: this.fromdate + " 00:00:00",
        edat: this.todate + " 23:59:59",
      };

      this.$store
        .dispatch("exec_solar_byweek", nform)
        .then((res) => {
          if (res != null && res.length > 0) {
            //console.log("exec_solar_byweek", res);
            this.genWeekChart(res, "每周發電度數");
          } else {
            res = [];
            this.genWeekChart(res, "每周發電度數");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    monthBtn() {
      let start = moment(this.fromdate);
      let end = moment(this.todate);

      start = end.subtract(1, "months").format("YYYY-MM-DD");
      //  console.log(start, end);
      this.fromdate = start;
      this.monthSearch();
    },
    monthSearch() {
      let nform = {
        ip_adrs: this.ip_adrs,
        sdat: this.fromdate + " 00:00:00",
        edat: this.todate + " 23:59:59",
      };
      this.$store
        .dispatch("exec_solar_bymonth", nform)
        .then((res) => {
          if (res != null && res.length > 0) {
            //console.log("exec_solar_bymonth", res);
            this.genMonthChart(res, "每周發電度數");
          } else {
            res = [];
            this.genMonthChart(res, "每月發電度數");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    yearBtn() {
      let sdat = new Date().toISOString().substr(0, 10);
      let edat = new Date().toISOString().substr(0, 10);

      this.fromdate = sdat;
      this.todate = edat;

      let start = moment(this.fromdate);
      let end = moment(this.todate);
      start = end.subtract(1, "years").format("YYYY-MM-DD");
      //  console.log(start, end);
      this.fromdate = start;
      this.yearSearch();
    },
    yearSearch() {
      let nform = {
        ip_adrs: this.ip_adrs,
        sdat: this.fromdate + " 00:00:00",
        edat: this.todate + " 23:59:59",
      };

      this.$store
        .dispatch("exec_solar_byyear", nform)
        .then((res) => {
          if (res != null && res.length > 0) {
            //console.log("exec_solar_byyear", res);
            this.genYearChart(res, "每年發電度數");
          } else {
            res = [];
            this.genYearChart(res, "每年發電度數");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    todayBtn() {
      let sdat = new Date().toISOString().substr(0, 10);
      let edat = new Date().toISOString().substr(0, 10);
      this.searchType = "today";
      this.fromdate = sdat;
      this.todate = edat;

      let nform = {
        ip_adrs: this.ip_adrs,
        sdat: sdat,
        edat: edat,
      };
      this.$store
        .dispatch("exec_solar_byhour", nform)
        .then((res) => {
          if (res != null && res.length > 0) {
            // console.log("exec_solar_byhour", res);
            this.genTodayChart(res, "每小時發電度數");
          } else {
            res = [];
            this.genTodayChart(res, "每小時發電度數");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    genTodayChart(res, title) {
      let that = this;

      let labels = [];
      let datasets = [];
      let dataarr = [];
      let dataarrBar = [];

      for (var i = 1; i < 25; i++) {
        let has = false;
        for (var j = 0; j < res.length; j++) {
          let item = res[j];
          // console.log(item);
          let hh = parseInt(item.hh);
          let eac_today = parseFloat(item.eac_today);
          if (i == hh) {
            // console.log(eac_today, this.dashboard.build_value);
            let val = eac_today / this.dashboard.build_value;
            val = val.toFixed(2);
            // console.log(val);
            has = true;
            dataarr.push(val);
            dataarrBar.push(eac_today);
          }
        }

        labels.push(i);
        if (has) {
        } else {
          dataarr.push(0);
          dataarrBar.push(0);
        }
      }

      datasets = [
        {
          type: "line",
          label: "每Kwp系統-小時發電",
          borderColor: "black",
          pointBackgroundColor: "white",
          borderWidth: 1,
          yAxisID: "y-axis-2",
          pointBorderColor: "white",
          data: dataarr,
          pointBackgroundColor: "black",
        },
        {
          type: "bar",
          label: title,
          borderWidth: 1,
          yAxisID: "y-axis-1",
          data: dataarrBar,
          backgroundColor: "rgb(124, 181, 236)",
          borderColor: "rgb(124, 181, 236)",
        },
      ];

      that.chartAna = {
        labels: labels,
        datasets: datasets,
      };
    },
    genYearChart(res, title) {
      let that = this;

      let labels = [];
      let datasets = [];
      let dataarr = [];
      let dataarrBar = [];

      for (var j = 0; j < res.length; j++) {
        let item = res[j];
        // console.log(item);
        let yy = parseInt(item.yy);
        let eac_today = parseFloat(item.eac_today);
        let val = eac_today / this.dashboard.build_value;
        val = val.toFixed(2);
        dataarr.push(val);
        labels.push(yy);
        dataarrBar.push(eac_today);
      }

      datasets = [
        {
          type: "line",
          label: "每Kwp系統-小時發電",
          borderColor: "black",
          pointBackgroundColor: "white",
          borderWidth: 1,
          yAxisID: "y-axis-2",
          pointBorderColor: "white",
          data: dataarr,
          pointBackgroundColor: "black",
        },
        {
          type: "bar",
          label: title,
          borderWidth: 1,
          data: dataarrBar,
          yAxisID: "y-axis-1",
          backgroundColor: "rgb(124, 181, 236)",
          borderColor: "rgb(124, 181, 236)",
        },
      ];

      that.chartAna = {
        labels: labels,
        datasets: datasets,
      };
    },
    genMonthChart(res, title) {
      let that = this;

      let labels = [];
      let datasets = [];
      let dataarr = [];
      let dataarrBar = [];

      for (var j = 0; j < res.length; j++) {
        let item = res[j];
        // console.log(item);
        let yy = parseInt(item.yy);
        let monthly = parseInt(item.monthly);
        let eac_today = parseFloat(item.eac_today);
        let val = eac_today / this.dashboard.build_value;
        val = val.toFixed(2);
        dataarr.push(val);
        labels.push(yy + "-" + monthly);
        dataarrBar.push(eac_today);
      }

      datasets = [
        {
          type: "line",
          label: "每Kwp系統-小時發電",
          borderColor: "black",
          pointBackgroundColor: "white",
          borderWidth: 1,
          pointBorderColor: "white",
          data: dataarr,
          yAxisID: "y-axis-2",
          pointBackgroundColor: "black",
        },
        {
          type: "bar",
          label: title,
          borderWidth: 1,
          yAxisID: "y-axis-1",
          data: dataarrBar,
          backgroundColor: "rgb(124, 181, 236)",
          borderColor: "rgb(124, 181, 236)",
        },
      ];

      that.chartAna = {
        labels: labels,
        datasets: datasets,
      };
    },
    genWeekChart(res, title) {
      let that = this;

      let labels = [];
      let datasets = [];
      let dataarr = [];
      let dataarrBar = [];
      for (var j = 0; j < res.length; j++) {
        let item = res[j];
        // console.log(item);
        let yy = parseInt(item.yy);
        let weeks = parseInt(item.weeks);
        let eac_today = parseFloat(item.eac_today);
        let val = eac_today / this.dashboard.build_value;
        val = val.toFixed(0);
        dataarr.push(val);
        labels.push(yy + "-" + weeks);
        dataarrBar.push(eac_today);
      }

      datasets = [
        {
          type: "line",
          label: "每Kwp系統-小時發電",
          borderColor: "black",
          pointBackgroundColor: "white",
          borderWidth: 1,
          yAxisID: "y-axis-2",
          pointBorderColor: "white",
          data: dataarr,
          pointBackgroundColor: "black",
        },
        {
          type: "bar",
          label: title,
          borderWidth: 1,
          data: dataarrBar,
          yAxisID: "y-axis-1",
          backgroundColor: "rgb(124, 181, 236)",
          borderColor: "rgb(124, 181, 236)",
        },
      ];

      that.chartAna = {
        labels: labels,
        datasets: datasets,
      };
    },
  },
};
</script>

<style lang="scss">
.chartSolarDiv {
  flex-grow: 1;
  min-height: 0;

  > div {
    position: relative;
    height: 300px;
    width: 100%;

    > div {
      height: 300px;
      width: 100%;

      > canvas {
        height: 300px !important;
        width: 100% !important;
      }
    }
  }
}
</style>

<style>

.margin20{
  margin-top:50px;
}
.chartSolar {
    width: 100% !important;
  margin-right: 10px;
  float: left;
  height: 100% !important;
  max-height: 200px !important;
}

.radius {
  border-radius: 10px;
  border-width: 5px;
  border-color: red;
  width: 100%;
  height: 100%;
}

.imgIcon {
  float: left;
}

.iconRight {
  float: right;
  margin-right: 10px;
}

.date.v-input input,
.theme--light.v-input textarea {
  color: white !important;
}

.date .theme--light.v-icon {
  color: white !important;
}

.dateselect {
  color: white;
}

.table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.textred {
  color: #cc3333;
}

.table td,
.table th {
  border: 1px solid #ccc;
  padding: 10px;
}

.table .redbg {
  background: #cc3333;
  color: white;
}

/*第一欄第一列：左上*/
.table tr:first-child td:first-child {
  border-top-left-radius: 10px;
}
/*第一欄最後列：左下*/
.table tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}
/*最後欄第一列：右上*/
.table tr:first-child td:last-child {
  border-top-right-radius: 10px;
}
/*最後欄第一列：右下*/
.table tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}

.img {
  width: 20px;
  height: 20px;
}

.imgSelectDate {
  width: 80px;
  height: 80px;
  margin-right: 5px;
  background: white;
}

.left {
  float: left;
}

.status {
  line-height: 48px;
  margin-right: 10px;
}

.lineheight40 {
  line-height: 60px;
}

.both {
  clear: both;
}

.searchbg {
  background: #cc3333;
  border-radius: 10px;
  padding: 10px;
}
</style>